// Combined game data for all decks
import { CITY_CARDS } from './cityCardData';
import { WORLD_CITY_CARDS } from './worldCityCardData';
import { BIRD_CARDS } from './birdCardData';
import { STATE_CARDS } from './stateCardData';
import { COUNTRY_CARDS } from './countryCardData';
import { TALL_TREE_CARDS } from './tallTreeCardData';
import { BOY_NAME_CARDS } from './boyNameCardData';
import { GIRL_NAME_CARDS } from './girlNameCardData';
import { WORD_CARDS } from './wordCardData';
import { CHAOS_CARDS } from './chaosCardData';
import { DOG_BREED_CARDS } from './dogBreedCardData';
import { SOCCER_CARDS } from './soccerCardData';
import { GLOBAL_CHAIN_CARDS } from './globalChainCardData';
import { FOOTBALL_CARDS } from './footballCardData';
import { COLORS_CARDS } from './colorsCardData';
import { ANNOYANCES_CARDS } from './annoyancesCardData';
import { WAR_CARDS } from './warCardData';
import { NONSENSE_CARDS } from './nonsenseCardData';
import { SWIFT_SONGS_CARDS } from './swiftSongsCardData';
import { PEOPLE_CARDS } from './peopleCardData';
import { ACTOR_AWARDS_CARDS } from './actorAwardsCardData';
import { MUSIC_CARDS } from './musicCardData';
import { ANIMALS_CARDS } from './animalsCardData';
import { CARS_CARDS } from './carsCardData';
import { GLOBAL_BIRTHS_CARDS } from './globalBirthsCardData';
import { RIVERS_CARDS } from './riversCardData';
import { BEATLES_SONGS_CARDS } from './beatlesSongsCardData';
import { COUNTRIES_MATH_SCORES_CARDS } from './countriesMathScoresCardData';
import { COUNTRIES_TRADE_AGREEMENTS_CARDS } from './countriesTradeAgreementsCardData';
import { ARTISTS_TOP_40_CARDS } from './artistsTop40CardData';
import { BASEBALL_HOMERUN_CARDS } from './baseballHomerunCardData';
import { BASEBALL_WINS_CARDS } from './baseballWinsCardData';
import { MJ_SONGS_CARDS } from './mjSongsCardData';
import { STONES_SONGS_CARDS } from './stonesSongsCardData';
import { DRAKE_SONGS_CARDS } from './drakeSongsCardData';
import { MADONNA_SONGS_CARDS } from './madonnaSongsCardData';
import { ELTON_SONGS_CARDS } from './eltonSongsCardData';
import { HORSE_BREEDS_CARDS } from './horseBreedsCardData';
import { NBA_TEAMS_CARDS } from './nbaTeamsCardData';
import { MLB_TEAMS_CARDS } from './mlbTeamsCardData';
import { NHL_TEAMS_CARDS } from './nhlTeamsCardData';
import { NHL_MASCOTS_CARDS } from './nhlMascotsCardData';
import { PRINCE_SONGS_CARDS } from './princeSongsCardData';
import { CAT_BREEDS_CARDS } from './catBreedsCardData';
import { FLOWERS_CARDS } from './flowersCardData';
import { MOVIES_CARDS } from './moviesCardData';
import { CHAMPIONSHIPS_CARDS } from './championshipsCardData';
import { SHARKS_CARDS } from './sharksCardData';
import { BOX_OFFICE_CARDS } from './boxOfficeCardData';
import { DINOSAURS_CARDS } from './dinosaursCardData';
import { TV_SHOWS_CARDS } from './tvShowsCardData';
import { SNAKES_CARDS } from './snakesCardData';
import { OLYMPIC_MEDALS_CARDS } from './olympicMedalsCardData';
import { BOOKS_CLASSIC_CARDS } from './booksClassicCardData';
import { BOOKS_MODERN_CARDS } from './booksModernCardData';
import { BANDS_CARDS } from './bandsCardData';
import { COUNTING_CROWS_CARDS } from './countingCrowsCardData';
import { WARREN_ZEVON_CARDS } from './warrenZevonCardData';
import { NBA_PLAYERS_ALLTIME_CARDS } from './nbaPlayersAllTimeCardData';
import { MOVIE_QUOTES_CARDS } from './movieQuotesCardData';
import { PRESIDENTS_CARDS } from './presidentsCardData';
import { GAMING_CHARACTERS_CARDS } from './gamingCharactersCardData';
import { BOARD_GAMES_CARDS } from './boardGamesCardData';
import { CANDY_CARDS } from './candyCardData';
import { SOFT_DRINKS_CARDS } from './softDrinksCardData';
import { ICE_CREAM_CARDS } from './iceCreamCardData';
import { PIZZA_TOPPINGS_CARDS } from './pizzaToppingsCardData';
import { GAMING_CONSOLES_CARDS } from './gamingConsolesCardData';
import { VIDEO_GAMES_CARDS } from './videoGamesCardData';
import { POKEMON_CARDS } from './pokemonCardData';
import { COUNTRIES_GDP_CARDS } from './countriesGdpCardData';
import { ROMANTIC_COMEDIES_CARDS } from './romanticComediesCardData';
import { LEADING_MEN_CARDS } from './leadingMenCardData';
import { LEADING_LADIES_CARDS } from './leadingLadiesCardData';
import { CEREALS_CARDS } from './cerealsCardData';
import { SCOTUS_CARDS } from './scotusCardData';
import { UNDERRATED_MOVIES_CARDS } from './underratedMoviesCardData';
import { CULT_CLASSICS_CARDS } from './cultClassicsCardData';
import { NFL_QUARTERBACKS_CARDS } from './nflQuarterbacksCardData';
import { HORROR_MOVIES_CARDS } from './horrorMoviesCardData';
import { SNL_CAST_CARDS } from './snlCastCardData';
import { VIDEO_GAME_FRANCHISES_CARDS } from './videoGameFranchisesCardData';
import { HOT_PEPPERS_CARDS } from './hotPeppersCardData';
import { ONE_HIT_WONDERS_CARDS } from './oneHitWondersCardData';
import { PHOBIAS_CARDS } from './phobiasCardData';
import { LANGUAGES_CARDS } from './languagesCardData';
import { NINTENDO_CHARACTERS_CARDS } from './nintendoCharactersCardData';
import { BEER_BRANDS_CARDS } from './beerBrandsCardData';
import { ARCADE_CLASSICS_CARDS } from './arcadeClassicsCardData';
import { airJordansData } from './airJordansData';
import { luxuryWatchesData } from './luxuryWatchesData';
import { fashionBrandsData } from './fashionBrandsData';
import { designerHandbagsData } from './designerHandbagsData';
import { colognesData } from './colognesData';
import { perfumesData } from './perfumesData';
import { sneakerBrandsData } from './sneakerBrandsData';
import { cocktailsData } from './cocktailsData';
import { marvelCharactersData } from './marvelCharactersData';
import { beyonceSongsData } from './beyonceSongsData';
import { billionairesData } from './billionairesData';
import { eminemSongsData } from './eminemSongsData';
import { adeleSongsData } from './adeleSongsData';
import { whitneySongsData } from './whitneySongsData';
import { tallestBuildingsData } from './tallestBuildingsData';

export const DECK_TYPES = {
  US_CITIES: 'us_cities',
  WORLD_CITIES: 'world_cities',
  BIRDS: 'birds',
  STATES: 'states',
  COUNTRIES: 'countries',
  TALL_TREES: 'tall_trees',
  BOY_NAMES: 'boy_names',
  GIRL_NAMES: 'girl_names',
  WORDS: 'words',
  CHAOS: 'chaos',
  DOG_BREEDS: 'dog_breeds',
  SOCCER: 'soccer',
  GLOBAL_CHAINS: 'global_chains',
  FOOTBALL: 'football',
  COLORS: 'colors',
  ANNOYANCES: 'annoyances',
  WAR: 'war',
  NONSENSE: 'nonsense',
  SWIFT_SONGS: 'swift_songs',
  PEOPLE: 'people',
  ACTOR_AWARDS: 'actor_awards',
  MUSIC: 'music',
  ANIMALS: 'animals',
  CARS: 'cars',
  GLOBAL_BIRTHS: 'global_births',
  RIVERS: 'rivers',
  BEATLES_SONGS: 'beatles_songs',
  COUNTRIES_MATH_SCORES: 'countries_math_scores',
  COUNTRIES_TRADE_AGREEMENTS: 'countries_trade_agreements',
  ARTISTS_TOP_40: 'artists_top_40',
  BASEBALL_HOMERUN: 'baseball_homerun',
  BASEBALL_WINS: 'baseball_wins',
  MJ_SONGS: 'mj_songs',
  STONES_SONGS: 'stones_songs',
  DRAKE_SONGS: 'drake_songs',
  MADONNA_SONGS: 'madonna_songs',
  ELTON_SONGS: 'elton_songs',
  HORSE_BREEDS: 'horse_breeds',
  NBA_TEAMS: 'nba_teams',
  MLB_TEAMS: 'mlb_teams',
  NHL_TEAMS: 'nhl_teams',
  NHL_MASCOTS: 'nhl_mascots',
  PRINCE_SONGS: 'prince_songs',
  CAT_BREEDS: 'cat_breeds',
  FLOWERS: 'flowers',
  MOVIES: 'movies',
  CHAMPIONSHIPS: 'championships',
  SHARKS: 'sharks',
  BOX_OFFICE: 'box_office',
  DINOSAURS: 'dinosaurs',
  TV_SHOWS: 'tv_shows',
  SNAKES: 'snakes',
  OLYMPIC_MEDALS: 'olympic_medals',
  BOOKS_CLASSIC: 'books_classic',
  BOOKS_MODERN: 'books_modern',
  BANDS: 'bands',
  COUNTING_CROWS: 'counting_crows',
  WARREN_ZEVON: 'warren_zevon',
  NBA_PLAYERS_ALLTIME: 'nba_players_alltime',
  MOVIE_QUOTES: 'movie_quotes',
  PRESIDENTS: 'presidents',
  GAMING_CHARACTERS: 'gaming_characters',
  BOARD_GAMES: 'board_games',
  CANDY: 'candy',
  SOFT_DRINKS: 'soft_drinks',
  ICE_CREAM: 'ice_cream',
  PIZZA_TOPPINGS: 'pizza_toppings',
  POKEMON: 'pokemon',
  COUNTRIES_GDP: 'countries_gdp',
  ROMANTIC_COMEDIES: 'romantic_comedies',
  LEADING_MEN: 'leading_men',
  LEADING_LADIES: 'leading_ladies',
  CEREALS: 'cereals',
  SCOTUS: 'scotus',
  UNDERRATED_MOVIES: 'underrated_movies',
  CULT_CLASSICS: 'cult_classics',
  NFL_QUARTERBACKS: 'nfl_quarterbacks',
  HORROR_MOVIES: 'horror_movies',
  SNL_CAST: 'snl_cast',
  GAMING_CONSOLES: 'gaming_consoles',
  VIDEO_GAMES: 'video_games',
  VIDEO_GAME_FRANCHISES: 'video_game_franchises',
  HOT_PEPPERS: 'hot_peppers',
  ONE_HIT_WONDERS: 'one_hit_wonders',
  PHOBIAS: 'phobias',
  LANGUAGES: 'languages',
  NINTENDO_CHARACTERS: 'nintendo_characters',
  BEER_BRANDS: 'beer_brands',
  ARCADE_CLASSICS: 'arcade_classics',
  AIR_JORDANS: 'air_jordans',
  LUXURY_WATCHES: 'luxury_watches',
  FASHION_BRANDS: 'fashion_brands',
  DESIGNER_HANDBAGS: 'designer_handbags',
  COLOGNES: 'colognes',
  PERFUMES: 'perfumes',
  SNEAKER_BRANDS: 'sneaker_brands',
  COCKTAILS: 'cocktails',
  MARVEL_CHARACTERS: 'marvel_characters',
  BEYONCE_SONGS: 'beyonce_songs',
  BILLIONAIRES: 'billionaires',
  EMINEM_SONGS: 'eminem_songs',
  ADELE_SONGS: 'adele_songs',
  WHITNEY_SONGS: 'whitney_songs',
  TALLEST_BUILDINGS: 'tallest_buildings'
};

// Thematic categories for deck organization
export const CATEGORIES = {
  THE_GLOBE: 'the_globe',
  LIVING_THINGS: 'living_things',
  MUSIC: 'music',
  MOVIES: 'movies',
  ENTERTAINMENT: 'entertainment',
  SPORTS: 'sports',
  EPHEMERA: 'the_abyss',
  FOOD_AND_DRINK: 'food_and_drink',
  GAMING: 'gaming',
  STYLE: 'style',
  RANDOM: 'random'
};

// Difficulty levels for banners
export const DIFFICULTY = {
  EASY: 'easy',
  DIFFICULT: 'difficult',
  IMPOSSIBLE: 'impossible'
};

export const DECK_INFO = {
  [DECK_TYPES.US_CITIES]: {
    name: 'Cities - U.S.',
    description: 'Battle of US City Popularity',
    cards: CITY_CARDS,
    icon: '🇺🇸',
    category: CATEGORIES.THE_GLOBE,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-blue-400',
      to: 'to-blue-600',
      border: 'border-blue-500',
      bg: 'bg-blue-500'
    }
  },
  [DECK_TYPES.WORLD_CITIES]: {
    name: 'Cities - World',
    description: 'Global Metropolitan Areas',
    cards: WORLD_CITY_CARDS,
    icon: '🌆',
    category: CATEGORIES.THE_GLOBE,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-cyan-400',
      to: 'to-cyan-600',
      border: 'border-cyan-500',
      bg: 'bg-cyan-500'
    }
  },
  [DECK_TYPES.BIRDS]: {
    name: 'Birds',
    description: 'North American Bird Popularity',
    cards: BIRD_CARDS,
    icon: '🐦',
    category: CATEGORIES.LIVING_THINGS,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-sky-300',
      to: 'to-sky-500',
      border: 'border-sky-400',
      bg: 'bg-sky-400'
    }
  },
  [DECK_TYPES.STATES]: {
    name: 'States',
    description: 'US States by Popularity',
    cards: STATE_CARDS,
    icon: '🗺️',
    category: CATEGORIES.THE_GLOBE,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-indigo-400',
      to: 'to-indigo-600',
      border: 'border-indigo-500',
      bg: 'bg-indigo-500'
    }
  },
  [DECK_TYPES.COUNTRIES]: {
    name: 'Countries',
    description: 'World Countries by Population',
    cards: COUNTRY_CARDS,
    icon: '🌍',
    category: CATEGORIES.THE_GLOBE,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-emerald-400',
      to: 'to-emerald-600',
      border: 'border-emerald-500',
      bg: 'bg-emerald-500'
    }
  },
  [DECK_TYPES.TALL_TREES]: {
    name: 'Tall Trees',
    description: 'World\'s Tallest Tree Species',
    promptText: 'Which is taller?',
    cards: TALL_TREE_CARDS,
    icon: '🌲',
    category: CATEGORIES.LIVING_THINGS,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-green-500',
      to: 'to-green-700',
      border: 'border-green-600',
      bg: 'bg-green-600'
    }
  },
  [DECK_TYPES.BOY_NAMES]: {
    name: 'Names - Boy',
    description: 'Popular U.S. Boy Names',
    cards: BOY_NAME_CARDS,
    icon: '👦',
    category: CATEGORIES.LIVING_THINGS,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-blue-300',
      to: 'to-blue-500',
      border: 'border-blue-400',
      bg: 'bg-blue-400'
    }
  },
  [DECK_TYPES.GIRL_NAMES]: {
    name: 'Names - Girl',
    description: 'Popular U.S. Girl Names',
    cards: GIRL_NAME_CARDS,
    icon: '👧',
    category: CATEGORIES.LIVING_THINGS,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-pink-300',
      to: 'to-pink-500',
      border: 'border-pink-400',
      bg: 'bg-pink-400'
    }
  },
  [DECK_TYPES.WORDS]: {
    name: 'Words',
    description: 'Most Common English Words',
    cards: WORD_CARDS,
    icon: '📝',
    category: CATEGORIES.EPHEMERA,
    difficulty: DIFFICULTY.IMPOSSIBLE,
    colors: {
      from: 'from-slate-400',
      to: 'to-slate-600',
      border: 'border-slate-500',
      bg: 'bg-slate-500'
    }
  },
  [DECK_TYPES.CHAOS]: {
    name: 'Chaos',
    description: 'Random Eclectic Mix',
    cards: CHAOS_CARDS,
    icon: '🌪️',
    category: CATEGORIES.EPHEMERA,
    difficulty: DIFFICULTY.IMPOSSIBLE,
    colors: {
      from: 'from-violet-400',
      to: 'to-violet-600',
      border: 'border-violet-500',
      bg: 'bg-violet-500'
    }
  },
  [DECK_TYPES.DOG_BREEDS]: {
    name: 'Dog Breeds',
    description: 'Popular Dog Breed Rankings',
    cards: DOG_BREED_CARDS,
    icon: '🐕',
    category: CATEGORIES.LIVING_THINGS,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-amber-400',
      to: 'to-amber-600',
      border: 'border-amber-500',
      bg: 'bg-amber-500'
    }
  },
  [DECK_TYPES.SOCCER]: {
    name: 'Soccer',
    description: 'Top Soccer Nations',
    cards: SOCCER_CARDS,
    icon: '⚽',
    category: CATEGORIES.SPORTS,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-green-400',
      to: 'to-green-600',
      border: 'border-green-500',
      bg: 'bg-green-500'
    }
  },
  [DECK_TYPES.GLOBAL_CHAINS]: {
    name: 'Global Chains',
    description: 'Worldwide Food & Beverage Chains',
    cards: GLOBAL_CHAIN_CARDS,
    icon: '🍔',
    category: CATEGORIES.FOOD_AND_DRINK,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-red-400',
      to: 'to-yellow-500',
      border: 'border-red-500',
      bg: 'bg-red-500'
    }
  },
  [DECK_TYPES.FOOTBALL]: {
    name: 'Football',
    description: 'NFL Team Rankings',
    cards: FOOTBALL_CARDS,
    icon: '🏈',
    category: CATEGORIES.SPORTS,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-orange-500',
      to: 'to-orange-700',
      border: 'border-orange-600',
      bg: 'bg-orange-600'
    }
  },
  [DECK_TYPES.COLORS]: {
    name: 'Colors',
    description: 'Rainbow of color popularity',
    cards: COLORS_CARDS,
    icon: '🎨',
    category: CATEGORIES.EPHEMERA,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-rose-400',
      to: 'to-purple-500',
      border: 'border-rose-500',
      bg: 'bg-rose-500'
    }
  },
  [DECK_TYPES.ANNOYANCES]: {
    name: 'Annoyances',
    description: 'Things that drive you crazy',
    cards: ANNOYANCES_CARDS,
    icon: '😤',
    category: CATEGORIES.EPHEMERA,
    difficulty: DIFFICULTY.IMPOSSIBLE,
    colors: {
      from: 'from-gray-400',
      to: 'to-gray-600',
      border: 'border-gray-500',
      bg: 'bg-gray-500'
    }
  },
  [DECK_TYPES.WAR]: {
    name: 'War',
    description: 'Military Weapons & Vehicles',
    cards: WAR_CARDS,
    icon: '⚔️',
    category: CATEGORIES.EPHEMERA,
    difficulty: DIFFICULTY.IMPOSSIBLE,
    colors: {
      from: 'from-stone-500',
      to: 'to-stone-700',
      border: 'border-stone-600',
      bg: 'bg-stone-600'
    }
  },
  [DECK_TYPES.NONSENSE]: {
    name: 'Nonsense',
    description: 'Words that make no sense',
    cards: NONSENSE_CARDS,
    icon: '🤪',
    category: CATEGORIES.EPHEMERA,
    difficulty: DIFFICULTY.IMPOSSIBLE,
    colors: {
      from: 'from-fuchsia-400',
      to: 'to-fuchsia-600',
      border: 'border-fuchsia-500',
      bg: 'bg-fuchsia-500'
    }
  },
  [DECK_TYPES.SWIFT_SONGS]: {
    name: 'Taylor Swift',
    description: 'Taylor Swift Hit Rankings',
    cards: SWIFT_SONGS_CARDS,
    icon: '💜',
    category: CATEGORIES.MUSIC,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-pink-400',
      to: 'to-purple-500',
      border: 'border-pink-500',
      bg: 'bg-pink-500'
    }
  },
  [DECK_TYPES.PEOPLE]: {
    name: 'Celebrities',
    description: 'Celebrity Popularity Rankings',
    promptText: 'Who is more popular?',
    cards: PEOPLE_CARDS,
    icon: '🌟',
    category: CATEGORIES.ENTERTAINMENT,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-yellow-300',
      to: 'to-yellow-500',
      border: 'border-yellow-400',
      bg: 'bg-yellow-400'
    }
  },
  [DECK_TYPES.ACTOR_AWARDS]: {
    name: 'Actor Awards',
    description: 'Oscar Nomination Rankings',
    promptText: 'Who has won more?',
    cards: ACTOR_AWARDS_CARDS,
    icon: '🏆',
    category: CATEGORIES.MOVIES,
    difficulty: DIFFICULTY.IMPOSSIBLE,
    colors: {
      from: 'from-yellow-500',
      to: 'to-amber-700',
      border: 'border-yellow-600',
      bg: 'bg-yellow-600'
    }
  },
  [DECK_TYPES.MUSIC]: {
    name: 'Artists',
    description: 'Top Musical Artists & Bands',
    cards: MUSIC_CARDS,
    icon: '🎵',
    category: CATEGORIES.MUSIC,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-purple-400',
      to: 'to-purple-600',
      border: 'border-purple-500',
      bg: 'bg-purple-500'
    }
  },
  [DECK_TYPES.ANIMALS]: {
    name: 'Animals',
    description: 'Popular Animal Rankings',
    cards: ANIMALS_CARDS,
    icon: '🐾',
    category: CATEGORIES.LIVING_THINGS,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-lime-400',
      to: 'to-lime-600',
      border: 'border-lime-500',
      bg: 'bg-lime-500'
    }
  },
  [DECK_TYPES.CARS]: {
    name: 'Cars',
    description: 'Top Car Brands',
    cards: CARS_CARDS,
    icon: '🚗',
    category: CATEGORIES.EPHEMERA,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-neutral-400',
      to: 'to-neutral-600',
      border: 'border-neutral-500',
      bg: 'bg-neutral-500'
    }
  },
  [DECK_TYPES.GLOBAL_BIRTHS]: {
    name: 'Countries - Global Births',
    description: 'Countries ranked by annual births',
    cards: GLOBAL_BIRTHS_CARDS,
    icon: '👶',
    category: CATEGORIES.THE_GLOBE,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-teal-400',
      to: 'to-cyan-600',
      border: 'border-teal-500',
      bg: 'bg-teal-500'
    }
  },
  [DECK_TYPES.RIVERS]: {
    name: 'Rivers',
    description: 'World Rivers by Water Discharge',
    promptText: 'Which is longer?',
    cards: RIVERS_CARDS,
    icon: '🌊',
    category: CATEGORIES.THE_GLOBE,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-blue-500',
      to: 'to-indigo-700',
      border: 'border-blue-600',
      bg: 'bg-blue-600'
    }
  },
  [DECK_TYPES.BEATLES_SONGS]: {
    name: 'Beatles',
    description: 'The Beatles Hit Rankings',
    cards: BEATLES_SONGS_CARDS,
    icon: '🎸',
    category: CATEGORIES.MUSIC,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-yellow-400',
      to: 'to-orange-500',
      border: 'border-yellow-500',
      bg: 'bg-yellow-500'
    }
  },
  [DECK_TYPES.COUNTRIES_MATH_SCORES]: {
    name: 'Countries - Math Scores',
    description: 'Countries by Math Assessment Rankings',
    cards: COUNTRIES_MATH_SCORES_CARDS,
    icon: '🧮',
    category: CATEGORIES.THE_GLOBE,
    difficulty: DIFFICULTY.IMPOSSIBLE,
    colors: {
      from: 'from-blue-500',
      to: 'to-indigo-600',
      border: 'border-blue-500',
      bg: 'bg-blue-500'
    }
  },
  [DECK_TYPES.COUNTRIES_TRADE_AGREEMENTS]: {
    name: 'Countries - Trade Agreements',
    description: 'Countries by Number of Trade Deals',
    promptText: 'Which country has more trade agreements?',
    cards: COUNTRIES_TRADE_AGREEMENTS_CARDS,
    icon: '🤝',
    category: CATEGORIES.THE_GLOBE,
    difficulty: DIFFICULTY.IMPOSSIBLE,
    colors: {
      from: 'from-emerald-500',
      to: 'to-teal-600',
      border: 'border-emerald-500',
      bg: 'bg-emerald-500'
    }
  },
  [DECK_TYPES.ARTISTS_TOP_40]: {
    name: 'Artists - Top 40',
    description: 'Music Artists by Chart Success',
    promptText: 'Who has more hits?',
    cards: ARTISTS_TOP_40_CARDS,
    icon: '🎤',
    category: CATEGORIES.MUSIC,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-rose-500',
      to: 'to-pink-600',
      border: 'border-rose-500',
      bg: 'bg-rose-500'
    }
  },
  [DECK_TYPES.BASEBALL_HOMERUN]: {
    name: 'Baseball - Homerun Leaders',
    description: 'All-Time Career Home Run Leaders',
    promptText: 'Who has more homeruns?',
    cards: BASEBALL_HOMERUN_CARDS,
    icon: '⚾',
    category: CATEGORIES.SPORTS,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-red-600',
      to: 'to-blue-700',
      border: 'border-red-600',
      bg: 'bg-red-600'
    }
  },
  [DECK_TYPES.BASEBALL_WINS]: {
    name: 'Baseball - Wins Leaders',
    description: 'All-Time Career Pitching Wins Leaders',
    promptText: 'Who has more wins?',
    cards: BASEBALL_WINS_CARDS,
    icon: '⚾',
    category: CATEGORIES.SPORTS,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-green-600',
      to: 'to-blue-700',
      border: 'border-green-600',
      bg: 'bg-green-600'
    }
  },
  [DECK_TYPES.MJ_SONGS]: {
    name: 'Michael Jackson',
    description: 'King of Pop Hit Rankings',
    cards: MJ_SONGS_CARDS,
    icon: '🎤',
    category: CATEGORIES.MUSIC,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-red-500',
      to: 'to-yellow-400',
      border: 'border-red-500',
      bg: 'bg-red-500'
    }
  },
  [DECK_TYPES.STONES_SONGS]: {
    name: 'Rolling Stones',
    description: 'Greatest Rock Band Hit Rankings',
    cards: STONES_SONGS_CARDS,
    icon: '🎸',
    category: CATEGORIES.MUSIC,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-red-600',
      to: 'to-black',
      border: 'border-red-600',
      bg: 'bg-red-600'
    }
  },
  [DECK_TYPES.DRAKE_SONGS]: {
    name: 'Drake',
    description: 'The 6 God Hit Rankings',
    cards: DRAKE_SONGS_CARDS,
    icon: '🦉',
    category: CATEGORIES.MUSIC,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-amber-500',
      to: 'to-black',
      border: 'border-amber-500',
      bg: 'bg-amber-500'
    }
  },
  [DECK_TYPES.MADONNA_SONGS]: {
    name: 'Madonna',
    description: 'Queen of Pop Hit Rankings',
    cards: MADONNA_SONGS_CARDS,
    icon: '👑',
    category: CATEGORIES.MUSIC,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-pink-500',
      to: 'to-purple-600',
      border: 'border-pink-500',
      bg: 'bg-pink-500'
    }
  },
  [DECK_TYPES.ELTON_SONGS]: {
    name: 'Elton John',
    description: 'Rocket Man Hit Rankings',
    cards: ELTON_SONGS_CARDS,
    icon: '🚀',
    category: CATEGORIES.MUSIC,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-yellow-400',
      to: 'to-red-500',
      border: 'border-yellow-400',
      bg: 'bg-yellow-400'
    }
  },
  [DECK_TYPES.HORSE_BREEDS]: {
    name: 'Horse Breeds',
    description: 'Popular Horse Breed Rankings',
    cards: HORSE_BREEDS_CARDS,
    icon: '🐴',
    category: CATEGORIES.LIVING_THINGS,
    difficulty: DIFFICULTY.IMPOSSIBLE,
    colors: {
      from: 'from-amber-600',
      to: 'to-amber-800',
      border: 'border-amber-600',
      bg: 'bg-amber-600'
    }
  },
  [DECK_TYPES.NBA_TEAMS]: {
    name: 'NBA Teams',
    description: 'Basketball Team Rankings',
    cards: NBA_TEAMS_CARDS,
    icon: '🏀',
    category: CATEGORIES.SPORTS,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-orange-500',
      to: 'to-red-600',
      border: 'border-orange-500',
      bg: 'bg-orange-500'
    }
  },
  [DECK_TYPES.MLB_TEAMS]: {
    name: 'MLB Teams',
    description: 'Baseball Team Rankings',
    cards: MLB_TEAMS_CARDS,
    icon: '⚾',
    category: CATEGORIES.SPORTS,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-red-600',
      to: 'to-blue-700',
      border: 'border-red-600',
      bg: 'bg-red-600'
    }
  },
  [DECK_TYPES.NHL_TEAMS]: {
    name: 'NHL Teams',
    description: 'Hockey Team Rankings',
    cards: NHL_TEAMS_CARDS,
    icon: '🏒',
    category: CATEGORIES.SPORTS,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-blue-600',
      to: 'to-gray-800',
      border: 'border-blue-600',
      bg: 'bg-blue-600'
    }
  },
  [DECK_TYPES.NHL_MASCOTS]: {
    name: 'NHL Mascots',
    description: 'Hockey Mascot Coolness Rankings',
    cards: NHL_MASCOTS_CARDS,
    icon: '🦁',
    category: CATEGORIES.SPORTS,
    difficulty: DIFFICULTY.IMPOSSIBLE,
    colors: {
      from: 'from-orange-500',
      to: 'to-purple-600',
      border: 'border-orange-500',
      bg: 'bg-orange-500'
    }
  },
  [DECK_TYPES.PRINCE_SONGS]: {
    name: 'Prince',
    description: 'Purple One Hit Rankings',
    cards: PRINCE_SONGS_CARDS,
    icon: '☔',
    category: CATEGORIES.MUSIC,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-purple-600',
      to: 'to-yellow-400',
      border: 'border-purple-600',
      bg: 'bg-purple-600'
    }
  },
  [DECK_TYPES.CAT_BREEDS]: {
    name: 'Cat Breeds',
    description: 'Popular Cat Breed Rankings',
    cards: CAT_BREEDS_CARDS,
    icon: '🐱',
    category: CATEGORIES.LIVING_THINGS,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-orange-400',
      to: 'to-rose-500',
      border: 'border-orange-400',
      bg: 'bg-orange-400'
    }
  },
  [DECK_TYPES.FLOWERS]: {
    name: 'Flowers',
    description: 'Popular Flower Rankings',
    cards: FLOWERS_CARDS,
    icon: '🌸',
    category: CATEGORIES.LIVING_THINGS,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-pink-400',
      to: 'to-rose-500',
      border: 'border-pink-400',
      bg: 'bg-pink-400'
    }
  },
  [DECK_TYPES.MOVIES]: {
    name: 'All-Time',
    description: 'Greatest Films of All Time',
    cards: MOVIES_CARDS,
    icon: '🎬',
    category: CATEGORIES.MOVIES,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-amber-500',
      to: 'to-red-600',
      border: 'border-amber-500',
      bg: 'bg-amber-500'
    }
  },
  [DECK_TYPES.CHAMPIONSHIPS]: {
    name: 'Championships',
    description: 'Most Winning Teams Ever',
    promptText: 'Who won more?',
    cards: CHAMPIONSHIPS_CARDS,
    icon: '🏆',
    category: CATEGORIES.SPORTS,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-yellow-500',
      to: 'to-amber-600',
      border: 'border-yellow-500',
      bg: 'bg-yellow-500'
    }
  },
  [DECK_TYPES.SHARKS]: {
    name: 'Sharks',
    description: 'Ocean Predator Rankings',
    cards: SHARKS_CARDS,
    icon: '🦈',
    category: CATEGORIES.LIVING_THINGS,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-blue-600',
      to: 'to-slate-800',
      border: 'border-blue-600',
      bg: 'bg-blue-600'
    }
  },
  [DECK_TYPES.BOX_OFFICE]: {
    name: 'Box Office',
    description: 'Top Worldwide Grossing Films',
    promptText: 'Which made more at the box office?',
    cards: BOX_OFFICE_CARDS,
    icon: '🎟️',
    category: CATEGORIES.MOVIES,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-green-500',
      to: 'to-emerald-600',
      border: 'border-green-500',
      bg: 'bg-green-500'
    }
  },
  [DECK_TYPES.DINOSAURS]: {
    name: 'Dinosaurs',
    description: 'Prehistoric Creatures Ranked',
    cards: DINOSAURS_CARDS,
    icon: '🦕',
    category: CATEGORIES.EPHEMERA,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-amber-600',
      to: 'to-orange-700',
      border: 'border-amber-600',
      bg: 'bg-amber-600'
    }
  },
  [DECK_TYPES.PHOBIAS]: {
    name: 'Phobias',
    description: 'Common Fears Ranked',
    promptText: 'Which phobia is more common?',
    cards: PHOBIAS_CARDS,
    icon: '😱',
    category: CATEGORIES.EPHEMERA,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-purple-900',
      to: 'to-slate-900',
      border: 'border-purple-500',
      bg: 'bg-purple-900'
    }
  },
  [DECK_TYPES.TV_SHOWS]: {
    name: 'TV Shows',
    description: 'Episode Count + Cultural Impact',
    cards: TV_SHOWS_CARDS,
    icon: '📺',
    category: CATEGORIES.ENTERTAINMENT,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-blue-600',
      to: 'to-indigo-700',
      border: 'border-blue-600',
      bg: 'bg-blue-600'
    }
  },
  [DECK_TYPES.SNAKES]: {
    name: 'Snakes',
    description: 'Snake Popularity Rankings',
    cards: SNAKES_CARDS,
    icon: '🐍',
    category: CATEGORIES.LIVING_THINGS,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-green-600',
      to: 'to-emerald-800',
      border: 'border-green-600',
      bg: 'bg-green-600'
    }
  },
  [DECK_TYPES.OLYMPIC_MEDALS]: {
    name: 'Olympics - Medals',
    description: 'All-Time Medal Count by Country',
    promptText: 'Who won more?',
    cards: OLYMPIC_MEDALS_CARDS,
    icon: '🏅',
    category: CATEGORIES.SPORTS,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-yellow-600',
      to: 'to-amber-800',
      border: 'border-yellow-600',
      bg: 'bg-yellow-600'
    }
  },
  [DECK_TYPES.BOOKS_CLASSIC]: {
    name: 'Books - Classic',
    description: 'Pre-1970 Literature by Sales',
    cards: BOOKS_CLASSIC_CARDS,
    icon: '📚',
    category: CATEGORIES.ENTERTAINMENT,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-rose-800',
      to: 'to-rose-950',
      border: 'border-rose-700',
      bg: 'bg-rose-800'
    }
  },
  [DECK_TYPES.BOOKS_MODERN]: {
    name: 'Books - Modern',
    description: 'Post-1970 Literature by Sales',
    cards: BOOKS_MODERN_CARDS,
    icon: '📖',
    category: CATEGORIES.ENTERTAINMENT,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-teal-700',
      to: 'to-teal-900',
      border: 'border-teal-600',
      bg: 'bg-teal-700'
    }
  },
  [DECK_TYPES.BANDS]: {
    name: 'Bands',
    description: 'Greatest Bands by Album Sales',
    promptText: 'Who has more hits?',
    cards: BANDS_CARDS,
    icon: '🎸',
    category: CATEGORIES.MUSIC,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-purple-800',
      to: 'to-indigo-900',
      border: 'border-purple-600',
      bg: 'bg-purple-800'
    }
  },
  [DECK_TYPES.COUNTING_CROWS]: {
    name: 'Counting Crows',
    description: 'Counting Crows Hit Rankings',
    cards: COUNTING_CROWS_CARDS,
    icon: '🎵',
    category: CATEGORIES.MUSIC,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-amber-700',
      to: 'to-amber-900',
      border: 'border-amber-600',
      bg: 'bg-amber-700'
    }
  },
  [DECK_TYPES.WARREN_ZEVON]: {
    name: 'Warren Zevon',
    description: 'Excitable Boy Hit Rankings',
    cards: WARREN_ZEVON_CARDS,
    icon: '🐺',
    category: CATEGORIES.MUSIC,
    difficulty: DIFFICULTY.IMPOSSIBLE,
    colors: {
      from: 'from-slate-700',
      to: 'to-slate-900',
      border: 'border-slate-600',
      bg: 'bg-slate-700'
    }
  },
  [DECK_TYPES.NBA_PLAYERS_ALLTIME]: {
    name: 'NBA Players - All-Time',
    description: 'Greatest Basketball Players Ever',
    promptText: 'Who is more popular?',
    cards: NBA_PLAYERS_ALLTIME_CARDS,
    icon: '🏀',
    category: CATEGORIES.SPORTS,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-orange-700',
      to: 'to-orange-900',
      border: 'border-orange-600',
      bg: 'bg-orange-700'
    }
  },
  [DECK_TYPES.NFL_QUARTERBACKS]: {
    name: 'NFL Quarterbacks',
    description: 'Greatest QBs Ranked by Legacy',
    promptText: 'Who is more popular?',
    cards: NFL_QUARTERBACKS_CARDS,
    icon: '🏈',
    category: CATEGORIES.SPORTS,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-green-800',
      to: 'to-green-950',
      border: 'border-green-600',
      bg: 'bg-green-800'
    }
  },
  [DECK_TYPES.MOVIE_QUOTES]: {
    name: 'Quotes',
    description: 'Most Iconic Lines in Cinema',
    cards: MOVIE_QUOTES_CARDS,
    icon: '🎬',
    category: CATEGORIES.MOVIES,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-red-900',
      to: 'to-red-950',
      border: 'border-red-700',
      bg: 'bg-red-900'
    }
  },
  [DECK_TYPES.ROMANTIC_COMEDIES]: {
    name: 'Romantic Comedies',
    description: 'Rom-Coms Ranked by Popularity',
    cards: ROMANTIC_COMEDIES_CARDS,
    icon: '💕',
    category: CATEGORIES.MOVIES,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-pink-600',
      to: 'to-rose-800',
      border: 'border-pink-400',
      bg: 'bg-pink-600'
    }
  },
  [DECK_TYPES.LEADING_MEN]: {
    name: 'Leading Men',
    description: 'Top Actors Ranked by Popularity',
    promptText: 'Who is more popular?',
    cards: LEADING_MEN_CARDS,
    icon: '🎭',
    category: CATEGORIES.MOVIES,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-slate-700',
      to: 'to-indigo-900',
      border: 'border-slate-500',
      bg: 'bg-slate-700'
    }
  },
  [DECK_TYPES.LEADING_LADIES]: {
    name: 'Leading Ladies',
    description: 'Top Actresses Ranked by Popularity',
    promptText: 'Who is more popular?',
    cards: LEADING_LADIES_CARDS,
    icon: '👑',
    category: CATEGORIES.MOVIES,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-rose-700',
      to: 'to-pink-900',
      border: 'border-rose-500',
      bg: 'bg-rose-700'
    }
  },
  [DECK_TYPES.UNDERRATED_MOVIES]: {
    name: 'Underrated Movies',
    description: 'Cult Classics & Hidden Gems',
    cards: UNDERRATED_MOVIES_CARDS,
    icon: '💎',
    category: CATEGORIES.MOVIES,
    difficulty: DIFFICULTY.IMPOSSIBLE,
    promptText: 'Which is more popular?',
    colors: {
      from: 'from-teal-700',
      to: 'to-cyan-900',
      border: 'border-teal-500',
      bg: 'bg-teal-700'
    }
  },
  [DECK_TYPES.CULT_CLASSICS]: {
    name: 'Cult Classics',
    description: 'Midnight Movies & Devoted Fanbases',
    cards: CULT_CLASSICS_CARDS,
    icon: '🎬',
    category: CATEGORIES.MOVIES,
    difficulty: DIFFICULTY.IMPOSSIBLE,
    promptText: 'Which has a bigger cult following?',
    colors: {
      from: 'from-purple-800',
      to: 'to-fuchsia-900',
      border: 'border-purple-500',
      bg: 'bg-purple-800'
    }
  },
  [DECK_TYPES.HORROR_MOVIES]: {
    name: 'Horror',
    description: 'Scariest Films by Recognition',
    cards: HORROR_MOVIES_CARDS,
    icon: '🔪',
    category: CATEGORIES.MOVIES,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-red-950',
      to: 'to-black',
      border: 'border-red-800',
      bg: 'bg-red-950'
    }
  },
  [DECK_TYPES.SNL_CAST]: {
    name: 'TV - SNL Cast Members',
    description: 'Saturday Night Live Legends',
    promptText: 'Who is more popular?',
    cards: SNL_CAST_CARDS,
    icon: '🎤',
    category: CATEGORIES.ENTERTAINMENT,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-blue-800',
      to: 'to-indigo-950',
      border: 'border-yellow-500',
      bg: 'bg-blue-800'
    }
  },
  [DECK_TYPES.PRESIDENTS]: {
    name: 'U.S. Presidents',
    description: 'Ranked by Historical Impact',
    cards: PRESIDENTS_CARDS,
    icon: '🇺🇸',
    category: CATEGORIES.THE_GLOBE,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-blue-900',
      to: 'to-blue-950',
      border: 'border-blue-700',
      bg: 'bg-blue-900'
    }
  },
  [DECK_TYPES.COUNTRIES_GDP]: {
    name: 'Countries - Economic Growth',
    description: 'Ranked by GDP',
    cards: COUNTRIES_GDP_CARDS,
    icon: '💰',
    category: CATEGORIES.THE_GLOBE,
    difficulty: DIFFICULTY.IMPOSSIBLE,
    colors: {
      from: 'from-emerald-700',
      to: 'to-emerald-900',
      border: 'border-emerald-500',
      bg: 'bg-emerald-700'
    }
  },
  [DECK_TYPES.SCOTUS]: {
    name: 'Supreme Court Decisions',
    description: 'Landmark Cases by Public Awareness',
    cards: SCOTUS_CARDS,
    icon: '⚖️',
    category: CATEGORIES.THE_GLOBE,
    difficulty: DIFFICULTY.IMPOSSIBLE,
    promptText: 'Which is more well-known?',
    colors: {
      from: 'from-slate-800',
      to: 'to-indigo-950',
      border: 'border-amber-600',
      bg: 'bg-slate-800'
    }
  },
  [DECK_TYPES.LANGUAGES]: {
    name: 'Languages',
    description: 'Languages by Total Speakers',
    promptText: 'Which language has more speakers?',
    cards: LANGUAGES_CARDS,
    icon: '🗣️',
    category: CATEGORIES.THE_GLOBE,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-teal-700',
      to: 'to-blue-900',
      border: 'border-teal-400',
      bg: 'bg-teal-700'
    }
  },
  [DECK_TYPES.GAMING_CHARACTERS]: {
    name: 'Gaming Characters',
    description: 'Iconic Video Game Heroes & Villains',
    cards: GAMING_CHARACTERS_CARDS,
    icon: '🎮',
    category: CATEGORIES.GAMING,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-purple-700',
      to: 'to-purple-900',
      border: 'border-purple-500',
      bg: 'bg-purple-700'
    }
  },
  [DECK_TYPES.BOARD_GAMES]: {
    name: 'Board Games',
    description: 'Classic Tabletop Favorites',
    cards: BOARD_GAMES_CARDS,
    icon: '🎲',
    category: CATEGORIES.GAMING,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-amber-700',
      to: 'to-amber-900',
      border: 'border-amber-500',
      bg: 'bg-amber-700'
    }
  },
  [DECK_TYPES.CANDY]: {
    name: 'Candy',
    description: 'Sweet Treats Ranked by Popularity',
    cards: CANDY_CARDS,
    icon: '🍬',
    category: CATEGORIES.FOOD_AND_DRINK,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-pink-600',
      to: 'to-pink-800',
      border: 'border-pink-400',
      bg: 'bg-pink-600'
    }
  },
  [DECK_TYPES.SOFT_DRINKS]: {
    name: 'Soft Drinks',
    description: 'Sodas Ranked by Sales',
    cards: SOFT_DRINKS_CARDS,
    icon: '🥤',
    category: CATEGORIES.FOOD_AND_DRINK,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-red-700',
      to: 'to-red-900',
      border: 'border-red-500',
      bg: 'bg-red-700'
    }
  },
  [DECK_TYPES.ICE_CREAM]: {
    name: 'Ice Cream',
    description: 'Flavors Ranked by Popularity',
    cards: ICE_CREAM_CARDS,
    icon: '🍦',
    category: CATEGORIES.FOOD_AND_DRINK,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-fuchsia-600',
      to: 'to-fuchsia-800',
      border: 'border-fuchsia-400',
      bg: 'bg-fuchsia-600'
    }
  },
  [DECK_TYPES.PIZZA_TOPPINGS]: {
    name: 'Pizza Toppings',
    description: 'Toppings Ranked by Popularity',
    cards: PIZZA_TOPPINGS_CARDS,
    icon: '🍕',
    category: CATEGORIES.FOOD_AND_DRINK,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-red-500',
      to: 'to-orange-600',
      border: 'border-red-400',
      bg: 'bg-red-500'
    }
  },
  [DECK_TYPES.CEREALS]: {
    name: 'Breakfast Cereals',
    description: 'Cereals Ranked by Popularity',
    cards: CEREALS_CARDS,
    icon: '🥣',
    category: CATEGORIES.FOOD_AND_DRINK,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-amber-600',
      to: 'to-orange-700',
      border: 'border-amber-400',
      bg: 'bg-amber-600'
    }
  },
  [DECK_TYPES.HOT_PEPPERS]: {
    name: 'Hot Peppers',
    description: 'Peppers Ranked by Scoville',
    promptText: 'Which one is hotter?',
    cards: HOT_PEPPERS_CARDS,
    icon: '🌶️',
    category: CATEGORIES.FOOD_AND_DRINK,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-red-600',
      to: 'to-orange-600',
      border: 'border-red-400',
      bg: 'bg-red-600'
    }
  },
  [DECK_TYPES.BEER_BRANDS]: {
    name: 'Beer Brands',
    description: 'Beers Ranked by Global Sales',
    promptText: 'Which beer sells more?',
    cards: BEER_BRANDS_CARDS,
    icon: '🍺',
    category: CATEGORIES.FOOD_AND_DRINK,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-amber-700',
      to: 'to-yellow-900',
      border: 'border-amber-500',
      bg: 'bg-amber-700'
    }
  },
  [DECK_TYPES.ONE_HIT_WONDERS]: {
    name: 'One-Hit Wonders',
    description: 'One-Hit Wonders by Impact',
    promptText: 'Which was bigger?',
    cards: ONE_HIT_WONDERS_CARDS,
    icon: '🎤',
    category: CATEGORIES.MUSIC,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-pink-500',
      to: 'to-purple-600',
      border: 'border-pink-400',
      bg: 'bg-pink-500'
    }
  },
  [DECK_TYPES.POKEMON]: {
    name: 'Pokémon',
    description: 'Pokémon Ranked by Popularity',
    cards: POKEMON_CARDS,
    icon: '⚡',
    category: CATEGORIES.GAMING,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-yellow-500',
      to: 'to-amber-600',
      border: 'border-yellow-400',
      bg: 'bg-yellow-500'
    }
  },
  [DECK_TYPES.GAMING_CONSOLES]: {
    name: 'Gaming Consoles',
    description: 'Consoles Ranked by Sales',
    cards: GAMING_CONSOLES_CARDS,
    icon: '🕹️',
    category: CATEGORIES.GAMING,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-slate-700',
      to: 'to-slate-900',
      border: 'border-slate-500',
      bg: 'bg-slate-700'
    }
  },
  [DECK_TYPES.VIDEO_GAMES]: {
    name: 'Video Games',
    description: 'Best-Selling Games of All Time',
    cards: VIDEO_GAMES_CARDS,
    icon: '👾',
    category: CATEGORIES.GAMING,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-green-700',
      to: 'to-green-900',
      border: 'border-green-500',
      bg: 'bg-green-700'
    }
  },
  [DECK_TYPES.VIDEO_GAME_FRANCHISES]: {
    name: 'Video Game Franchises',
    description: 'Franchises Ranked by Total Sales',
    cards: VIDEO_GAME_FRANCHISES_CARDS,
    icon: '🎮',
    category: CATEGORIES.GAMING,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-red-600',
      to: 'to-purple-900',
      border: 'border-red-400',
      bg: 'bg-red-600'
    }
  },
  [DECK_TYPES.NINTENDO_CHARACTERS]: {
    name: 'Nintendo Characters',
    description: 'Iconic Nintendo Heroes & Villains',
    promptText: 'Which Nintendo character is more popular?',
    cards: NINTENDO_CHARACTERS_CARDS,
    icon: '🍄',
    category: CATEGORIES.GAMING,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-red-600',
      to: 'to-red-800',
      border: 'border-yellow-400',
      bg: 'bg-red-600'
    }
  },
  [DECK_TYPES.ARCADE_CLASSICS]: {
    name: 'Arcade Classics',
    description: 'Classic Arcade Games by Revenue',
    promptText: 'Which arcade game made more money?',
    cards: ARCADE_CLASSICS_CARDS,
    icon: '👾',
    category: CATEGORIES.GAMING,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-purple-900',
      to: 'to-black',
      border: 'border-pink-500',
      bg: 'bg-purple-900'
    }
  },
  [DECK_TYPES.AIR_JORDANS]: {
    name: 'Air Jordans',
    description: 'Most Iconic Jordan Sneakers by Resale Value',
    promptText: 'Which pair of Jordans are worth more?',
    cards: airJordansData,
    icon: '👟',
    category: CATEGORIES.STYLE,
    difficulty: DIFFICULTY.IMPOSSIBLE,
    colors: {
      from: 'from-red-600',
      to: 'to-black',
      border: 'border-red-500',
      bg: 'bg-red-600'
    }
  },
  [DECK_TYPES.LUXURY_WATCHES]: {
    name: 'Luxury Watches',
    description: 'Most Prestigious Timepieces by Resale Value',
    promptText: 'Which watch is worth more?',
    cards: luxuryWatchesData,
    icon: '⌚',
    category: CATEGORIES.STYLE,
    difficulty: DIFFICULTY.IMPOSSIBLE,
    colors: {
      from: 'from-amber-600',
      to: 'to-black',
      border: 'border-amber-500',
      bg: 'bg-amber-600'
    }
  },
  [DECK_TYPES.FASHION_BRANDS]: {
    name: 'Fashion Brands',
    description: 'Top Fashion Houses by Market Cap',
    promptText: 'Which brand is worth more?',
    cards: fashionBrandsData,
    icon: '👗',
    category: CATEGORIES.STYLE,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-pink-600',
      to: 'to-black',
      border: 'border-pink-500',
      bg: 'bg-pink-600'
    }
  },
  [DECK_TYPES.DESIGNER_HANDBAGS]: {
    name: 'Designer Handbags',
    description: 'Iconic Bags by Resale Value',
    promptText: 'Which bag is worth more?',
    cards: designerHandbagsData,
    icon: '👜',
    category: CATEGORIES.STYLE,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-rose-400',
      to: 'to-black',
      border: 'border-rose-400',
      bg: 'bg-rose-400'
    }
  },
  [DECK_TYPES.COLOGNES]: {
    name: 'Colognes',
    description: "Men's Fragrances by Popularity",
    promptText: 'Which is more popular?',
    cards: colognesData,
    icon: '🧴',
    category: CATEGORIES.STYLE,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-amber-400',
      to: 'to-black',
      border: 'border-amber-400',
      bg: 'bg-amber-400'
    }
  },
  [DECK_TYPES.PERFUMES]: {
    name: 'Perfumes',
    description: "Women's Fragrances by Popularity",
    promptText: 'Which is more popular?',
    cards: perfumesData,
    icon: '💐',
    category: CATEGORIES.STYLE,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-pink-400',
      to: 'to-purple-900',
      border: 'border-pink-400',
      bg: 'bg-pink-400'
    }
  },
  [DECK_TYPES.SNEAKER_BRANDS]: {
    name: 'Sneaker Brands',
    description: 'Footwear Companies by Revenue',
    promptText: 'Which has sold more?',
    cards: sneakerBrandsData,
    icon: '👟',
    category: CATEGORIES.STYLE,
    difficulty: DIFFICULTY.MEDIUM,
    colors: {
      from: 'from-orange-500',
      to: 'to-black',
      border: 'border-orange-500',
      bg: 'bg-orange-500'
    }
  },
  [DECK_TYPES.COCKTAILS]: {
    name: 'Cocktails',
    description: 'Popular Cocktails by Order Frequency',
    promptText: 'Which is more popular?',
    cards: cocktailsData,
    icon: '🍹',
    category: CATEGORIES.FOOD_AND_DRINK,
    difficulty: DIFFICULTY.EASY,
    colors: {
      from: 'from-pink-400',
      to: 'to-rose-600',
      border: 'border-pink-500',
      bg: 'bg-pink-500'
    }
  },
  [DECK_TYPES.MARVEL_CHARACTERS]: {
    name: 'Marvel Characters',
    description: 'Superheroes by Comic Appearances',
    promptText: 'Who has been in more comics?',
    cards: marvelCharactersData,
    icon: '🦸',
    category: CATEGORIES.ENTERTAINMENT,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-red-500',
      to: 'to-blue-600',
      border: 'border-red-500',
      bg: 'bg-red-500'
    }
  },
  [DECK_TYPES.BEYONCE_SONGS]: {
    name: 'Beyoncé',
    description: 'Queen Bey Hits by Chart Performance',
    promptText: 'Which charted higher?',
    cards: beyonceSongsData,
    icon: '👑',
    category: CATEGORIES.MUSIC,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-yellow-400',
      to: 'to-pink-600',
      border: 'border-yellow-400',
      bg: 'bg-yellow-400'
    }
  },
  [DECK_TYPES.BILLIONAIRES]: {
    name: 'Billionaires',
    description: 'Countries by Number of Billionaires',
    promptText: 'Which country has more?',
    cards: billionairesData,
    icon: '💰',
    category: CATEGORIES.THE_GLOBE,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-green-400',
      to: 'to-emerald-600',
      border: 'border-green-500',
      bg: 'bg-green-500'
    }
  },
  [DECK_TYPES.EMINEM_SONGS]: {
    name: 'Eminem',
    description: 'Slim Shady Hits by Streaming Popularity',
    promptText: 'Which is more popular?',
    cards: eminemSongsData,
    icon: '🎤',
    category: CATEGORIES.MUSIC,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-gray-800',
      to: 'to-red-700',
      border: 'border-red-600',
      bg: 'bg-red-600'
    }
  },
  [DECK_TYPES.ADELE_SONGS]: {
    name: 'Adele',
    description: 'Soulful Ballads by Chart Performance',
    promptText: 'Which is more popular?',
    cards: adeleSongsData,
    icon: '🎙️',
    category: CATEGORIES.MUSIC,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-blue-900',
      to: 'to-purple-700',
      border: 'border-purple-600',
      bg: 'bg-purple-600'
    }
  },
  [DECK_TYPES.WHITNEY_SONGS]: {
    name: 'Whitney Houston',
    description: 'The Voice - Greatest Hits by Popularity',
    promptText: 'Which is more popular?',
    cards: whitneySongsData,
    icon: '👑',
    category: CATEGORIES.MUSIC,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-yellow-500',
      to: 'to-rose-700',
      border: 'border-yellow-500',
      bg: 'bg-yellow-500'
    }
  },
  [DECK_TYPES.TALLEST_BUILDINGS]: {
    name: 'Tallest Buildings',
    description: 'World\'s Tallest Skyscrapers by Height',
    promptText: 'Which is taller?',
    cards: tallestBuildingsData,
    icon: '🏙️',
    category: CATEGORIES.THE_GLOBE,
    difficulty: DIFFICULTY.DIFFICULT,
    colors: {
      from: 'from-slate-600',
      to: 'to-slate-900',
      border: 'border-slate-500',
      bg: 'bg-slate-600'
    }
  }
};

export const GAME_MODES = {
  HUMAN_VS_HUMAN: 'human_vs_human',
  HUMAN_VS_COMPUTER: 'human_vs_computer'
};

export const shuffleCards = (cards) => {
  const shuffled = [...cards];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export const dealCards = (deckType = DECK_TYPES.US_CITIES) => {
  const selectedDeck = DECK_INFO[deckType].cards;
  const shuffledDeck = shuffleCards(selectedDeck);
  const player1Cards = shuffledDeck.slice(0, 5);
  const player2Cards = shuffledDeck.slice(5, 10);
  
  return {
    player1Cards: player1Cards.sort((a, b) => a.rank - b.rank), // Sort by rank for better display
    player2Cards: player2Cards.sort((a, b) => a.rank - b.rank),
    remainingCards: shuffledDeck.slice(10)
  };
};

// Shuffle array utility (Fisher-Yates)
export const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export const GAME_STATES = {
  GAME_SELECTOR: 'game_selector',
  WHICHING_HOUR: 'whiching_hour',
  JOURNEY: 'journey',
  DECK_SELECTION: 'deck_selection',
  MODE_SELECTION: 'mode_selection',
  WAITING: 'waiting',
  PLAYER1_TURN: 'player1_turn',
  PLAYER2_TURN: 'player2_turn',
  AI_THINKING: 'ai_thinking',
  TRICK_REVEAL: 'trick_reveal',
  GAME_OVER: 'game_over',
  GALLERY_VIEW: 'gallery_view',
  CATEGORY_SELECTION: 'category_selection'
};

export const PLAYERS = {
  PLAYER1: 'player1',
  PLAYER2: 'player2'
};